/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Launch_Submit_ActionInputs */

const en_directory_launch_submit_action = /** @type {(inputs: Directory_Launch_Submit_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Submit`)
};

const zh_directory_launch_submit_action = /** @type {(inputs: Directory_Launch_Submit_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`提交`)
};

/**
* | output |
* | --- |
* | "Submit" |
*
* @param {Directory_Launch_Submit_ActionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_launch_submit_action = /** @type {((inputs?: Directory_Launch_Submit_ActionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Launch_Submit_ActionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_launch_submit_action(inputs)
	return zh_directory_launch_submit_action(inputs)
});
export { directory_launch_submit_action as "directory.launch.submit_action" }